import React from 'react';
import Layout from '../../common/Layout';
import './styles.scss';

export default function Notifications() {
  return (
    <Layout>
      <h1>Notifications!</h1>
    </Layout>
  );
}
